import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'ms-page-title',
  imports: [],
  templateUrl: './page-title.component.html',
  standalone: true
})
export class PageTitleComponent {
  // Reads the active route's title so the heading and the browser tab can't drift apart. Placed
  // inside a page's own main-content card, so the injected route is that page's route.
  public title = toSignal(inject(ActivatedRoute).title);
}
